import React, { Component } from 'react';

import { Row, Col, Button } from 'react-bootstrap';

import logoBlue from "../../../img/Fina Validator logo Final_set color-03.png";

import i18n from "../../i18n";
import { Trans } from 'react-i18next';

export default class About extends Component {

	constructor(props) {
		super(props);
		this.state = {
			cardHeaderText: "About application",
			cardTitleText: "eSignature And eSeal Validation",
			cardText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse nec nisi molestie nibh viverra imperdiet quis id sapien. Nulla facilisi. Praesent suscipit ultrices erat et maximus. In non nulla augue. Duis suscipit rutrum sapien nec laoreet. Nullam ultricies justo turpis, et condimentum magna finibus vel. Suspendisse at varius risus. Donec sit amet mi cursus, vehicula turpis et, venenatis ante. Vestibulum magna ante, dignissim ac nunc non, fringilla molestie lacus. Maecenas hendrerit tincidunt tortor vel bibendum. Sed tincidunt lorem a volutpat sodales. Vestibulum sit amet turpis non justo ultricies sollicitudin id a ex. Quisque mollis magna at arcu pharetra posuere. Donec tempus tempor magna sit amet congue. Phasellus ut consectetur augue. Mauris facilisis lobortis ex, eget facilisis elit sollicitudin a. Nulla ullamcorper, est eu congue accumsan, risus leo fermentum tortor, at efficitur ligula elit eget orci. Sed in enim vitae odio ultrices condimentum eget et ex. Aliquam tempus vitae elit sed tempor. Nulla cursus luctus fringilla. Etiam posuere odio sed mi euismod ultricies. Praesent ut augue ac metus faucibus dignissim nec id libero. Proin ultrices vehicula dui, ut egestas augue aliquam eu. Donec volutpat quam at libero feugiat dapibus. Curabitur scelerisque iaculis mauris eu auctor. Proin turpis sapien, scelerisque at ex sed, lobortis viverra nulla. Praesent varius gravida risus non accumsan. Aenean libero nibh, pellentesque ac accumsan eu, efficitur eget lectus. Proin consectetur consectetur varius. Proin sed dui a purus aliquam maximus. Donec congue maximus arcu ut pulvinar. Donec commodo bibendum odio ac auctor. Proin auctor, nibh eu auctor condimentum, erat nisi viverra purus, eget tempus odio metus id nunc. Aenean aliquet ligula non nisi convallis, at vehicula metus venenatis. Quisque placerat nunc at tellus volutpat, in vehicula tellus pulvinar. Curabitur tempus dolor orci, ut tincidunt est tristique lobortis. Sed quis malesuada urna. Fusce ut nibh diam. Nulla facilisi. Aliquam eget ex in lorem faucibus tristique. Fusce vestibulum faucibus nisi, a venenatis elit pulvinar sit amet. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque pharetra quam ac erat egestas, feugiat tristique ipsum porttitor. Cras lacinia orci eu tempor volutpat. Donec imperdiet ex non interdum suscipit. Nulla vitae quam mauris. Donec maximus mauris ut arcu pulvinar, mollis sollicitudin est feugiat. In dapibus tincidunt viverra. Aliquam pretium nec quam quis consequat. Nulla vel feugiat tortor. Nam eu ligula metus."
		}
	}


	render() {
		return (
			<React.Fragment>
				{/* 				<Row>
					<br />
					<Col xs={4} style={{ "display": "block", "margin": "auto" }}>
						<img style={{ "width": "inherit" }} src={logoBlue}></img>
					</Col>
					<Col xs={8} style={{ "display": "block", "margin": "auto" }}>
						{i18n.t("home:about_text")}
					</Col>

				</Row> */}
				<div className="row justify-content-center">
					<div className="col-9 col-md-12">
						<div className="row justify-content-center no-gutters">
							<div className="col-auto">
								<img src={logoBlue} className="img-fluid" alt="Fina Validator logo"
									style={{ "height": "130px", "position": "relative", "top": "50%", "transform": "translateY(-50%)", "marginRight": "30px" }} />
							</div>
							<div className="col">
								<div className="px-2">
									<br />
									<p style={{ "marginLeft": "10px", "textAlign": "left", "marginTop": "0.5rem" }}>
										<Trans i18nKey="multiline">
											{i18n.t("home:about_text")}
										</Trans>
									</p>
								</div>
								<br />
							</div>
						</div>
					</div>
				</div>

				<br />
				<Row className="justify-content-center" id="start_validating">
					<Button data-scroll href={document.getElementById("endpoint").getAttribute("value") + "#validate"} style={{ backgroundColor: "#3f5c94", paddingLeft: "25px", paddingRight: "25px" }}>
						<Row className="justify-content-center text-center">{i18n.t("home:start_validating")}</Row>
					</Button>
				</Row>
			</React.Fragment>
		)
	}
}